import React, { useContext } from 'react';
import { Skeleton, SkeletonProps } from '@material-ui/lab';

const Context = React.createContext(false);

export const SkeletonProvider: React.FC<{ enabled: boolean }> = ({ enabled, ...rest }) => (
  <Context.Provider value={enabled} {...rest} />
);

type SkeletonizeProps<T extends React.ElementType> = React.PropsWithChildren<{
  as: T;
  SkeletonProps?: SkeletonProps;
}> &
  React.ComponentProps<T>;

export const Skeletonize = <T extends React.ElementType>(props: SkeletonizeProps<T>) => {
  const enabled = useContext(Context);
  const { as: As, children, SkeletonProps, ...rest } = props;

  return (
    <As {...rest}>{enabled ? <Skeleton aria-label='loading' {...SkeletonProps} /> : children}</As>
  );
};
